import { Component } from '@angular/core'

@Component({
  selector: 'flo-favorite-skeleton',
  templateUrl: './favorite-skeleton.component.html',
  styleUrls: ['./favorite.skeleton.component.scss']
})
export class FavoriteSkeletonComponent {}
